/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ThermalNetwork } from './ThermalNetwork';
/**
 * Thermal model.
 *
 * Contains the thermal network defined by nodes and edges, and mappings of which nodes
 * correspond to which losses and temperatures.
 */
export type ThermalModel = {
    component_file_type?: ThermalModel.component_file_type;
    network: ThermalNetwork;
    loss_map: Record<string, Record<string, number>>;
    temperature_map: Record<string, Record<string, number>>;
};
export namespace ThermalModel {
    export enum component_file_type {
        THERMAL_MODEL = 'ThermalModel',
    }
}

